// Module
var code = "<div class=\"switch-container\" [ngClass]=\"class\"> <ng-content></ng-content> <mat-slide-toggle class=\"switch\" [ngClass]=\"{'switch--margin-left-auto': hasSwitchMarginLeftAuto, 'is-enabled': isTrue}\" [checked]=\"isTrue\" [disabled]=\"isDisabled\" (change)=\"toggleSwitch()\" aria-label=\"toggle Switch\"> </mat-slide-toggle> </div>";
// Exports
module.exports = code;